import type { ListarCredenciaisFiltro } from '@/types/credencial'
import type { ListarAdministradoresQuery } from '@/types/administrador'
import type { ListarGuiasFiltro } from '@/types/guia'
import type { ListarOperadoresQuery } from '@/types/operador'
import type { ListarTiposCredenciaisFiltro } from '@/types/tipo-credencial'

export const guiasKeys = {
  all: ['guias'] as const,
  lists: () => [...guiasKeys.all, 'list'] as const,
  list: (filtro: ListarGuiasFiltro) => [...guiasKeys.lists(), filtro] as const,
  details: () => [...guiasKeys.all, 'detail'] as const,
  detail: (guiaId: string) => [...guiasKeys.details(), guiaId] as const,
  historico: (guiaId: string, pageNumber: number, pageSize: number) =>
    [...guiasKeys.detail(guiaId), 'historico', pageNumber, pageSize] as const,
  payloadHistorico: (guiaId: string, logId: string) =>
    [...guiasKeys.detail(guiaId), 'historico', logId, 'payload'] as const,
}

export const credenciaisKeys = {
  all: ['credenciais'] as const,
  lists: () => [...credenciaisKeys.all, 'list'] as const,
  list: (filtro: ListarCredenciaisFiltro) => [...credenciaisKeys.lists(), filtro] as const,
  details: () => [...credenciaisKeys.all, 'detail'] as const,
  detail: (credenciaisId: string) => [...credenciaisKeys.details(), credenciaisId] as const,
  permissoes: (credenciaisId: string) =>
    [...credenciaisKeys.all, 'permissoes', credenciaisId] as const,
  planosPagina: (credenciaisId: string) =>
    [...credenciaisKeys.all, 'planos', credenciaisId] as const,
  planos: (credenciaisId: string, filtro: { pageNumber: number; pageSize: number }) =>
    [...credenciaisKeys.planosPagina(credenciaisId), filtro] as const,
  tabelaPropriaPagina: (credenciaisId: string) =>
    [...credenciaisKeys.all, 'tabelaPropria', credenciaisId] as const,
  tabelaPropria: (
    credenciaisId: string,
    filtro: { busca: string; pageNumber: number; pageSize: number },
  ) => [...credenciaisKeys.tabelaPropriaPagina(credenciaisId), filtro] as const,
}

export const permissoesKeys = {
  all: ['permissoes'] as const,
  catalogo: () => [...permissoesKeys.all, 'catalogo'] as const,
  usuario: (usuarioBackofficeId: string) =>
    [...permissoesKeys.all, 'usuario', usuarioBackofficeId] as const,
}

export const tiposCredenciaisKeys = {
  all: ['tiposCredenciais'] as const,
  lists: () => [...tiposCredenciaisKeys.all, 'list'] as const,
  list: (filtro: ListarTiposCredenciaisFiltro) => [...tiposCredenciaisKeys.lists(), filtro] as const,
  details: () => [...tiposCredenciaisKeys.all, 'detail'] as const,
  detail: (tipoCredencialId: string) => [...tiposCredenciaisKeys.details(), tipoCredencialId] as const,
  interfaces: () => [...tiposCredenciaisKeys.all, 'interfaces'] as const,
}

export const lookupsKeys = {
  all: ['lookups'] as const,
  clientes: (termo: string) => [...lookupsKeys.all, 'clientes', termo] as const,
  operadoras: (termo: string) => [...lookupsKeys.all, 'operadoras', termo] as const,
  credenciais: (termo: string, clienteId: string | null) =>
    [...lookupsKeys.all, 'credenciais', termo, clienteId] as const,
  especialidades: (termo: string) => [...lookupsKeys.all, 'especialidades', termo] as const,
  conselhos: () => [...lookupsKeys.all, 'conselhos'] as const,
  profissionais: (clienteId: string, termo: string) =>
    [...lookupsKeys.all, 'profissionais', clienteId, termo] as const,
  tiposToken: () => [...lookupsKeys.all, 'tiposToken'] as const,
  tiposCredenciais: (operadoraId: string | null) =>
    [...lookupsKeys.all, 'tiposCredenciais', operadoraId] as const,
  tiposArquivos: () => [...lookupsKeys.all, 'tiposArquivos'] as const,
  usuariosDisponiveis: (credencialId: string, termo: string) =>
    [...lookupsKeys.all, 'usuariosDisponiveis', credencialId, termo] as const,
  unidadesDisponiveis: (credencialId: string, termo: string) =>
    [...lookupsKeys.all, 'unidadesDisponiveis', credencialId, termo] as const,
}

export const dashboardKeys = {
  all: ['dashboard'] as const,
  indicadores: () => [...dashboardKeys.all, 'indicadores'] as const,
  saude: () => [...dashboardKeys.all, 'saude'] as const,
  alertas: () => [...dashboardKeys.all, 'alertas'] as const,
  preferenciaIndicadores: (perfil: string) =>
    [...dashboardKeys.all, 'preferencia-indicadores', perfil] as const,
}

export const operadoresKeys = {
  all: ['operadores'] as const,
  lists: () => [...operadoresKeys.all, 'list'] as const,
  list: (query: ListarOperadoresQuery) => [...operadoresKeys.lists(), query] as const,
}

export const administradoresKeys = {
  all: ['administradores'] as const,
  lists: () => [...administradoresKeys.all, 'list'] as const,
  list: (query: ListarAdministradoresQuery) => [...administradoresKeys.lists(), query] as const,
}
